// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".formatter-pod-images[data-v-4e5e0379]{word-break:break-all}", ""]);
// Exports
module.exports = exports;
